export default __webpack_public_path__ + "static/media/rusgot-screenshot-03.9f1685d4.png";